import React, { Component } from "react";
import JubileeListsRow from "./JubileeListsRow";
import db from "../../api/db";
import CircularProgress from "@material-ui/core/CircularProgress";

class JubileeLists extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clients: [],
      loading: false
    };
  }

  componentDidMount() {
    this.searchQuery();
  }

  searchQuery() {
    this.setState({
      loading: true
    });
    db.query("client", {
      subscriptions: "jubilee"
    }).then(response => {
      var clients = response.data.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.setState({
        clients: clients,
        loading: false
      });
    });
  }

  render() {
    const clients = this.state.clients;

    return (
      <React.Fragment>
        <h3>Jubilantlister</h3>
        {this.state.loading ? <CircularProgress size={20} /> : null}
        <table className="strict">
          <thead>
            <tr>
              <th>Kunde</th>
              <th>Aktiv periode</th>
              <th>Antall personer</th>
              <th>Neste utsending</th>
              <th>Sist varslet</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {clients.map((item, i) => (
              <JubileeListsRow
                key={i}
                Client={item}
                Row={i % 2 ? "odd" : "even"}
              />
            ))}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default JubileeLists;
